import { Component } from 'react'

import { Stack } from '@mui/material'
import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'

import { DEFAULT_ROUTES } from '../constants/config/routeVars'


interface ErrorProps {
  errorType?: string
  errorInfo?: string
  children?: any
}

export default class ErrorBoundary extends Component<ErrorProps> {
  public state: {
    hasError: boolean
    error: Error | null
    errorInfo: string
    errorType: string
  }

  constructor(props: ErrorProps) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      errorInfo: '',
      errorType: props.errorType ? props.errorType : 'default',
    }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    this.setState({
      error,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      errorInfo,
    })
  }

  render() {
    const { error, hasError } = this.state
    if (hasError) {
      const errorText =
        process.env.NEXT_PUBLIC_ENV === 'development'
          ? 'Chunk Error'
          : 'Website was updated'
      const errorPrefix =
        process.env.NEXT_PUBLIC_ENV === 'development'
          ? 'It is wrong:'
          : 'Unanticipated deviation:'
      const errorString =
        (error && typeof error.toString === 'function' && error.toString()) ||
        'UNKONW ERROR'
      const { errorType, errorInfo } = this.state
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const errorStack = errorInfo.componentStack
      const isChunkError = errorString.includes('ChunkLoadError')
      return (
        <Stack sx={{ height: '80vh', width: '100%', pb: 4 }}>
          <Alert
            elevation={6}
            variant="filled"
            severity={isChunkError ? 'warning' : errorType ? 'error' : 'info'}
            sx={{ my: '10vh', py: '10vh', mx: 3 }}
          >
            {isChunkError ? (
              <Typography variant="h6">
                {errorText}, please reload page...
              </Typography>
            ) : (
              <Typography variant="h6">
                {errorPrefix}
                {errorType} - {errorString}
              </Typography>
            )}
            <a href={DEFAULT_ROUTES.root}>Go HOME</a>
            <details style={{ whiteSpace: 'pre-wrap' }}>
              {errorString}
              <br />
              <pre style={{ whiteSpace: 'pre-wrap' }}>{errorStack}</pre>
            </details>
          </Alert>
        </Stack>
      )
    }

    return this.props.children
  }
}
